import { render, staticRenderFns } from "./OffCanvasComponent.vue?vue&type=template&id=433bdec8&scoped=true&"
import script from "./OffCanvasComponent.vue?vue&type=script&lang=js&"
export * from "./OffCanvasComponent.vue?vue&type=script&lang=js&"
import style0 from "./OffCanvasComponent.vue?vue&type=style&index=0&id=433bdec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bdec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('433bdec8')) {
      api.createRecord('433bdec8', component.options)
    } else {
      api.reload('433bdec8', component.options)
    }
    module.hot.accept("./OffCanvasComponent.vue?vue&type=template&id=433bdec8&scoped=true&", function () {
      api.rerender('433bdec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/OffCanvasComponent.vue"
export default component.exports